module.exports = __webpack_public_path__ + "img/IMG-20200319-WA0063.54b24833.jpg";